/* eslint-disable */
import requestDev from '@/utils/requestDev'
import requestRaw from '@/utils/requestRaw'
import { APIReportPHP, APICore } from '@/utils/servicesApi'
const qs = require('qs')

export function listWidgetChatMode() {
    return requestRaw({
        url: APICore() + '/toolkit/widget-chat/list-mode-widget',
        method: 'GET',
    })
}
export function updateWidgetChatDraft(params) {
    return requestDev({
        url: APIReportPHP() + '/toolkit/widget_chat/update_draft',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function updateWidgetChatPublish(params) {
    return requestDev({
        url: APIReportPHP() + '/toolkit/widget_chat/update_publish',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function storeWidgetChat(data) {
    return requestRaw({
        url: APICore() + '/toolkit/widget-chat/stored',
        method: 'POST',
        data: data // untuk array data post
    })
}

export function detailWidgetChat(id) {
    return requestRaw({
        url: APICore() + '/toolkit/widget-chat/detail?id=' + id,
        method: 'GET',
    })
}

export function detailEditWidgetChat(params) {
    return requestDev({
        url: APIReportPHP() + '/toolkit/widget_chat/detail_edit',
        method: 'POST',
        data: qs.stringify(params)
    })
}

export function listWidgetChat(params) {
    return requestDev({
        url: APIReportPHP() + '/toolkit/widget_chat/list',
        method: 'POST',
        data: qs.stringify(params)
    })
}


export function checkSlugLinkGenerator(data) {
    return requestRaw({
        url: APICore() + '/toolkit/link-generator/check-slug',
        method: 'POST',
        data: data // untuk array data post
    })
}

export function generateSlugLinkGenerator(data) {
    return requestRaw({
        url: APICore() + '/toolkit/link-generator/generate-slug',
        method: 'POST',
        data: data // untuk array data post
    })
}

export function listRotationType() {
    return requestRaw({
        url: APICore() + '/toolkit/link-generator/list-rotation-type',
        method: 'GET',
    })
}

export function listDomainLinkGenerator() {
    return requestDev({
        url: APIReportPHP() + '/toolkit/link_generator/domain',
        method: 'GET',
    })
}

export function storeLinkGenerator(data) {
    return requestRaw({
        url: APICore() + '/toolkit/link-generator/stored',
        method: 'POST',
        data: data // untuk array data post
    })
}

export function detailLinkGenerator(params) {
    return requestDev({
        url: APIReportPHP() + '/toolkit/link_generator/detail',
        method: 'POST',
        data: qs.stringify(params)
    })
}

export function listLinkGenerator(params) {
    return requestDev({
        url: APIReportPHP() + '/toolkit/link_generator/list',
        method: 'POST',
        data: qs.stringify(params)
    })
}

export function updateLinkGeneratorDraft(params) {
    return requestDev({
        url: APIReportPHP() + '/toolkit/link_generator/update_draft',
        method: 'POST',
        data: qs.stringify(params)
    })
}

export function updateLinkGeneratorPublish(params) {
    return requestDev({
        url: APIReportPHP() + '/toolkit/link_generator/update_publish',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function updateOperatorDraft(params) {
    return requestDev({
        url: APIReportPHP() + '/toolkit/operator/update_draft',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function updateOperatorPublish(params) {
    return requestDev({
        url: APIReportPHP() + '/toolkit/operator/update_publish',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function deleteOperator(params) {
    return requestDev({
        url: APIReportPHP() + '/toolkit/operator/delete',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function detailOperator(params) {
    return requestDev({
        url: APIReportPHP() + '/toolkit/operator/detail',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function listOperator(params) {
    return requestDev({
        url: APIReportPHP() + '/toolkit/operator/list',
        method: 'POST',
        data: qs.stringify(params)
    })
}

export function storeWorkingHours(data) {
    return requestRaw({
        url: APICore() + '/toolkit/working-hours/stored',
        method: 'POST',
        data: data // untuk array data post
    })
}
export function detailWorkingHours() {
    return requestDev({
        url: APIReportPHP() + '/toolkit/working-hours/detail',
        method: 'GET'
    })
}

export function storeOperator(data) {
    return requestRaw({
        url: APICore() + '/toolkit/operator/stored',
        method: 'POST',
        data: data // untuk array data post
    })
}


// WEBPACK FOOTER //
// ./src/api/toolkit.js